import { Injectable } from '@angular/core';
import { Chart, Tooltip } from 'chart.js/auto';
import * as moment from 'moment';
import * as _ from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class TootipService {

  constructor() { }
  tooltipPositionHandeler(){
    Tooltip.positioners.nearest = function (elements, eventPosition) {
      // A reference to the tooltip model
      const tooltip = this;
      return {
        x: eventPosition.x,
        y: eventPosition.y
        // You may also include xAlign and yAlign to override those tooltip options.
      };
    };

  }
  tooltipHandler(context: any, chartConfig:any){
    const { chart, tooltip, tooltip:{dataPoints}} = context;
    const canvaseRect = chart.canvas?.getBoundingClientRect();
    let tooltipFields = _.get(chartConfig, 'tooltipFields', [])
    const tooltipData = _.get(chartConfig, 'tooltipData', [])
    const tooltipId = _.get(chartConfig, 'tooltipId', '');
    const dataIndex = _.get(dataPoints, '[0].dataIndex', 0);
    let tooltipEl: any = document.getElementById(tooltipId);
    const tooltipRect = tooltipEl?.getBoundingClientRect()
    let tooltipValues: any = [];
    let tooltipTitle: string = '';
    

    if (tooltipEl && tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return {
        tooltipData,
        tooltipTitle
      };
    }

    if (tooltip.body) {
      const titleLines = tooltip.title || [];
      const bodyLines = tooltip.body.map((b: any) => b.lines);
      _.each(titleLines, (title: any) => {
        if ((tooltipId == 'bar-chart-tooltip' || tooltipId == 'chartjs-tooltip') && moment(title).isValid()) {
          if(chartConfig.trendType == "Quarterly"){
            tooltipTitle = moment(title).format('MMM')+"-"+moment(title).endOf('quarter').format('MMM')+" "+ moment(title).format("'YY");
          } else {
            tooltipTitle = moment(title).format(chartConfig.dateFormats[chartConfig.trendType])
          }
        } else {
          tooltipTitle = title
        }
      })
      
      if (_.isEmpty(tooltipFields)) {
        _.each(bodyLines, (line: any, index: number) => {
          if (line.length > 0) {
            let value = line[0]
            let data: any = line[0].split(':')
            if (data.length > 1) {
              value = data[1]
              tooltipValues.push({
                order: index + 1,
                label: data[0].trim(),
                value: value
              });
            } else {
              value = parseInt(data[0].trim())
              tooltipValues.push({
                order: index + 1,
                label: "Value",
                value: value
              });
            }
          }
        })
      }

      if (!_.isEmpty(tooltipFields)) {
        tooltipFields = _.sortBy(tooltipFields, ['order']);
        _.each(tooltipFields, (field: any) => {
          if (field.addInTooltip) {
            tooltipValues.push({
              order: field.order,
              label: field.header,
              value: this.getValue(tooltipData[dataIndex], field)
            });
          }
        })
      }
      
    }

    // Final coordinates
    let left =  tooltip.caretX + 10;
    // xAlign could be: `left`, `center`, `right`
    
    const centerX = chart.chartArea.width/2;
    if (tooltip.caretX < centerX) {
      left = tooltip.caretX + 10
    } else if (tooltip.caretX  > centerX) {
      left =  tooltip.caretX - (tooltipRect?.width + 15)
    } else {
      left =  tooltip.caretX - (tooltipRect?.width + 15)
    }
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left =left  + 'px';
    tooltipEl.style.top = tooltip.caretY + 'px';
    tooltipEl.style.transition = 'all .3s ease';

    return {
      tooltipValues,
      tooltipTitle
    };
  }

  getValue(object:any,field:any){
    if(field.showPercentage){
      return object[field.dataKey] + "( "+object.percent[field.dataKey]+"% )"
    }
    return object[field.dataKey]
  }
}
